

module.exports = __webpack_require__.stylable.create(
    "imagecover243152474",
    {"classes":{"root":"imagecover243152474__root"},"vars":{},"stVars":{},"keyframes":{"loading":"imagecover243152474__loading"}},
    "",
    1,
    /*! ../node_modules/@wix/search-box-v2/dist/src/components/ImageCover/ImageCover.st.css */ 1319,
    null
);
